import React, { FC } from 'react';
import { IconType } from '@app/components/ui/icons/icon.type';

const CloudMessageIcon: FC<IconType> = (props) => {
  const { size, className, customStyle } = props;
  return (
    <div className={className}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        style={customStyle}
        fill="none"
        viewBox="0 0 22 20"
      >
        <path
          fill="currentColor"
          d="M4.795 19.217c1.222 0 3.691-1.187 5.555-2.514 6.205.114 10.845-3.472 10.845-8.182 0-4.544-4.544-8.2-10.204-8.2S.796 3.976.796 8.52c0 2.891 1.793 5.466 4.544 6.811-.378.712-1.046 1.688-1.424 2.197-.562.747-.176 1.688.879 1.688m1.063-1.82c-.114.044-.158-.017-.079-.114.449-.545 1.108-1.415 1.433-2.03.264-.483.176-.905-.387-1.169-2.68-1.257-4.236-3.27-4.236-5.563 0-3.534 3.726-6.408 8.402-6.408s8.403 2.874 8.403 6.408c0 3.533-3.727 6.416-8.403 6.416-.158 0-.404-.01-.703-.01-.378-.008-.66.106-1.01.379-1.064.79-2.637 1.775-3.42 2.092"
        ></path>
      </svg>
    </div>
  );
};

export default CloudMessageIcon;
